import { defineLab, LAB_STATUS } from '@brightlocal/labs-sdk';

/** Website Performance report for a location. The component is a dynamic import so the lab is its own chunk. */
export const websitePerformanceLab = defineLab({
  id: 'website-performance',
  title: 'Website Performance',
  description: "How a location's website performs, with actions and fixes to improve it.",
  owner: 'platform-insights',
  flag: 'labs-website-performance-allowed',
  status: LAB_STATUS.INTERNAL,
  sunset: '2027-01-10',
  scope: 'location',
  component: () =>
    import('./WebsitePerformanceLab').then(({ WebsitePerformanceLab }) => ({ default: WebsitePerformanceLab }))
});
